import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { StreamCreatePage } from '@/features/admin/streams/stream-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau stream. */
export const Route = createFileRoute('/$tenant/streams/new')({ component: NewStreamRoute });

function NewStreamRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="streams"
      crumbs={[{ label: t('nav.items.streams') }, { label: t('admin.streams.newTitle') }]}
    >
      <StreamCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
